import { api } from '@/api/api-client';

/**
 * Stores message status updates using the edge function
 * This function should be called when a message's status changes
 * in local state to ensure those changes are persisted
 */
export async function storeMessageStatus(
  messageId: string,
  status: 'sent' | 'delivered' | 'read'
) {
  try {
    const response = await api<{ success: boolean; data: any }>(`/messages/${messageId}/status`, {
      method: 'PATCH',
      body: JSON.stringify({ status })
    });

    return { success: response.success, data: response.data };
  } catch (error) {
    console.error('Error storing message status:', error);
    return { success: false, error };
  }
}

/**
 * Stores status updates for all messages in a conversation
 * from a specific sender
 */
export async function storeAllMessageStatus(
  roomName: string,
  entityId: string,
  status: 'sent' | 'delivered' | 'read'
) {
  try {
    const response = await api<{ success: boolean; count: number }>('/messages/bulk-status', {
      method: 'PATCH',
      body: JSON.stringify({
        room_name: roomName,
        sender_id: entityId,
        status
      })
    });

    return { success: response.success, count: response.count };
  } catch (error) {
    console.error('Error in storeAllMessageStatus:', error);
    return { success: false, error };
  }
}